export const PROGETTI = [
  {
    id: "federica",
    prio: 1,
    cliente: "Sig.ra Federica",
    zona: "Appartamento · Zona Montagnola",
    cover: "/assets/lavori/federica/g2.jpg",
    lavori: [
      "Preparazione del sottofondo con graffiatura",
      "Posa parquet a correre",
      "Posa battiscopa",
      "Posa soglia d'ingresso",
    ],
    recensione: null,
    videos: [
      {
        src: "/assets/lavori/federica/v1.mp4",
        poster: "/assets/lavori/federica/pv1.jpg",
        label: "Posa a correre",
      },
    ],
    foto: [
      "/assets/lavori/federica/g2.jpg",
      "/assets/lavori/federica/g1.jpg",
      "/assets/lavori/federica/f5.jpg",
      "/assets/lavori/federica/f2.jpg",
      "/assets/lavori/federica/f3.jpg",
      "/assets/lavori/federica/g3.jpg",
      "/assets/lavori/federica/f4.jpg",
      "/assets/lavori/federica/f1.jpg",
      "/assets/lavori/federica/h3.jpg",
      "/assets/lavori/federica/h1.jpg",
      "/assets/lavori/federica/h2.jpg",
    ],
  },
  {
    id: "francesco",
    prio: 2,
    cliente: "Sig. Francesco",
    zona: "Appartamento · Zona Trastevere",
    cover: "/assets/lavori/francesco/t1.jpg",
    lavori: [
      "Lamatura parquet in olivo",
      "Verniciatura all'acqua",
    ],
    recensione: null,
    videos: [
      {
        src: "/assets/lavori/francesco/v1.mp4",
        poster: "/assets/lavori/francesco/pv1.jpg",
        label: "Lamatura",
      },
      {
        src: "/assets/lavori/francesco/v2.mp4",
        poster: "/assets/lavori/francesco/pv2.jpg",
      },
      {
        src: "/assets/lavori/francesco/v3.mp4",
        poster: "/assets/lavori/francesco/pv3.jpg",
        label: "Verniciatura",
      },
      {
        src: "/assets/lavori/francesco/v4.mp4",
        poster: "/assets/lavori/francesco/pv4.jpg",
      },
    ],
    foto: [
      "/assets/lavori/francesco/t1.jpg",
      "/assets/lavori/francesco/t5.jpg",
      "/assets/lavori/francesco/t2.jpg",
      "/assets/lavori/francesco/t4.jpg",
      "/assets/lavori/francesco/t3.jpg",
      "/assets/lavori/francesco/t6.jpg",
    ],
  },
  {
    id: "antonio",
    prio: 3,
    cliente: "Sig. Antonio",
    zona: "Appartamento · Zona Nomentana",
    cover: "/assets/lavori/antonio/c2.jpg",
    lavori: [
      "Preparazione con autolivellante",
      "Posa spina italiana",
      "Fornitura colla",
      "Posa battiscopa",
      "Posa soglia d'ingresso",
    ],
    recensione: null,
    videos: [
      {
        src: "/assets/lavori/antonio/v1.mp4",
        poster: "/assets/lavori/antonio/pv1.jpg",
        label: "Posa in corso",
      },
      {
        src: "/assets/lavori/antonio/v2.mp4",
        poster: "/assets/lavori/antonio/pv2.jpg",
        label: "La spina ultimata",
      },
    ],
    foto: [
      "/assets/lavori/antonio/c2.jpg",
      "/assets/lavori/antonio/c6.jpg",
      "/assets/lavori/antonio/b4.jpg",
      "/assets/lavori/antonio/a2.jpg",
      "/assets/lavori/antonio/c1.jpg",
      "/assets/lavori/antonio/c4.jpg",
      "/assets/lavori/antonio/c5.jpg",
      "/assets/lavori/antonio/b1.jpg",
      "/assets/lavori/antonio/b3.jpg",
      "/assets/lavori/antonio/a3.jpg",
    ],
  },
  {
    id: "greenhouse",
    prio: 9,
    cliente: "Palestra Green House",
    zona: "Ciampino · Morena",
    cover: "/assets/lavori/greenhouse/finito.jpg",
    lavori: ["Posa SPC", "Posa battiscopa", "Adeguamento di 2 porte"],
    recensione:
      "Serietà, professionalità e puntualità. Ottimo lavoro ragazzi. Saranno di certo loro a dare altri lavori per il nostro centro sportivo.",
    recensore: "Cristiano · Proprietario Green House",
    video: "/assets/lavori/greenhouse/v1.mp4",
    poster: "/assets/lavori/greenhouse/finito.jpg",
    foto: [
      "/assets/lavori/greenhouse/f1.jpg",
      "/assets/lavori/greenhouse/f2.jpg",
      "/assets/lavori/greenhouse/f5.jpg",
    ],
  },
  {
    id: "gabriele",
    prio: 10,
    cliente: "Sig. Gabriele",
    zona: "Ufficio · Zona Collatina",
    cover: "/assets/lavori/gabriele/p2.jpg",
    lavori: [
      "Posa SPC",
      "Adeguamento e taglio portone d'ingresso",
      "Adeguamento di 7 porte + mostre",
      "Montaggio soglia ingresso e bagni",
    ],
    recensione: null,
    videos: [
      {
        src: "/assets/lavori/gabriele/v1.mp4",
        poster: "/assets/lavori/gabriele/p1.jpg",
        label: "Prima della posa",
      },
      {
        src: "/assets/lavori/gabriele/v2.mp4",
        poster: "/assets/lavori/gabriele/p2.jpg",
        label: "Lavoro finito",
      },
    ],
    foto: [
      "/assets/lavori/gabriele/f2.jpg",
      "/assets/lavori/gabriele/f1.jpg",
    ],
  },
  {
    id: "fabrizio",
    prio: 9,
    cliente: "Sig. Fabrizio",
    zona: "Ufficio · Borghesiana",
    cover: "/assets/lavori/fabrizio/u3.jpg",
    lavori: [
      "Smontaggio e smaltimento vecchio pavimento",
      "Posa SPC",
      "Posa battiscopa",
      "Posa soglia d'ingresso in ogni stanza",
    ],
    recensione: null,
    videos: [
      {
        src: "/assets/lavori/fabrizio/v1.mp4",
        poster: "/assets/lavori/fabrizio/pv1.jpg",
        label: "Lavoro finito",
      },
    ],
    foto: [
      "/assets/lavori/fabrizio/u3.jpg",
      "/assets/lavori/fabrizio/u7.jpg",
      "/assets/lavori/fabrizio/u6.jpg",
      "/assets/lavori/fabrizio/u1.jpg",
      "/assets/lavori/fabrizio/u4.jpg",
      "/assets/lavori/fabrizio/u2.jpg",
      "/assets/lavori/fabrizio/u5.jpg",
    ],
  },
  {
    id: "nelu",
    prio: 11,
    cliente: "Sig. Nelu",
    zona: "Negozio · Via del Corso",
    cover: "/assets/lavori/nelu/f1.jpg",
    lavori: [
      "Posa in opera del parquet",
      "Rovere, doghe da 2,20 m × 15 cm",
    ],
    recensione: null,
    video: "/assets/lavori/nelu/v1.mp4",
    poster: "/assets/lavori/nelu/poster.jpg",
    foto: [
      "/assets/lavori/nelu/f1.jpg",
      "/assets/lavori/nelu/f2.jpg",
      "/assets/lavori/nelu/f3.jpg",
    ],
  },
  {
    id: "nicola",
    prio: 4,
    cliente: "Sig. Nicola",
    zona: "Appartamento · Zona Eur",
    cover: "/assets/lavori/nicola/m4.jpg",
    lavori: ["Posa SPC a spina ungherese", "Posa battiscopa", "Posa soglia d'ingresso"],
    recensione: null,
    videos: [
      {
        src: "/assets/lavori/nicola/v1.mp4",
        poster: "/assets/lavori/nicola/pv1.jpg",
        label: "Durante la posa",
      },
      {
        src: "/assets/lavori/nicola/v2.mp4",
        poster: "/assets/lavori/nicola/pv2.jpg",
      },
      {
        src: "/assets/lavori/nicola/v3.mp4",
        poster: "/assets/lavori/nicola/pv3.jpg",
        label: "Lavoro finito",
      },
    ],
    foto: [
      "/assets/lavori/nicola/m4.jpg",
      "/assets/lavori/nicola/m3.jpg",
      "/assets/lavori/nicola/n3.jpg",
      "/assets/lavori/nicola/n5.jpg",
      "/assets/lavori/nicola/m1.jpg",
      "/assets/lavori/nicola/m2.jpg",
      "/assets/lavori/nicola/m5.jpg",
      "/assets/lavori/nicola/n4.jpg",
      "/assets/lavori/nicola/n1.jpg",
      "/assets/lavori/nicola/n2.jpg",
      "/assets/lavori/nicola/n6.jpg",
    ],
  },
  {
    id: "sylvie",
    prio: 8,
    cliente: "Sig.ra Sylvie",
    zona: "Appartamento · Zona Boccea",
    cover: "/assets/lavori/sylvie/f1.jpg",
    lavori: ["Posa SPC", "Posa battiscopa"],
    recensione: null,
    videos: [
      {
        src: "/assets/lavori/sylvie/v1.mp4",
        poster: "/assets/lavori/sylvie/poster.jpg",
        label: "Cantiere",
      },
      {
        src: "/assets/lavori/sylvie/v2.mp4",
        poster: "/assets/lavori/sylvie/p2.jpg",
        label: "Lavoro finito",
      },
    ],
    foto: [
      "/assets/lavori/sylvie/f1.jpg",
      "/assets/lavori/sylvie/f2.jpg",
      "/assets/lavori/sylvie/f3.jpg",
      "/assets/lavori/sylvie/g1.jpg",
      "/assets/lavori/sylvie/g2.jpg",
      "/assets/lavori/sylvie/g3.jpg",
      "/assets/lavori/sylvie/g4.jpg",
      "/assets/lavori/sylvie/g5.jpg",
    ],
  },
  {
    id: "daniele",
    prio: 7,
    cliente: "Sig. Daniele",
    zona: "Appartamento · Monte Porzio",
    cover: "/assets/lavori/daniele/d3.jpg",
    lavori: ["Posa SPC", "Posa battiscopa", "Posa soglia d'ingresso"],
    recensione: null,
    videos: [
      {
        src: "/assets/lavori/daniele/v1.mp4",
        poster: "/assets/lavori/daniele/pv1.jpg",
        label: "Lavoro finito",
      },
    ],
    foto: [
      "/assets/lavori/daniele/d3.jpg",
      "/assets/lavori/daniele/d4.jpg",
      "/assets/lavori/daniele/d2.jpg",
      "/assets/lavori/daniele/d1.jpg",
    ],
  },
  {
    id: "ovidio",
    prio: 5,
    cliente: "Sig. Ovidio",
    zona: "Appartamento · Zona Nomentana",
    cover: "/assets/lavori/ovidio/o3.jpg",
    lavori: [
      "Posa spina italiana",
      "Preparazione del sottofondo",
      "Posa battiscopa",
      "Posa soglia d'ingresso",
    ],
    recensione: null,
    videos: [
      {
        src: "/assets/lavori/ovidio/v1.mp4",
        poster: "/assets/lavori/ovidio/pv1.jpg",
        label: "Posa in corso",
      },
      {
        src: "/assets/lavori/ovidio/v2.mp4",
        poster: "/assets/lavori/ovidio/pv2.jpg",
        label: "Lavoro finito",
      },
      {
        src: "/assets/lavori/ovidio/v3.mp4",
        poster: "/assets/lavori/ovidio/pv3.jpg",
      },
    ],
    foto: [
      "/assets/lavori/ovidio/o3.jpg",
      "/assets/lavori/ovidio/o2.jpg",
      "/assets/lavori/ovidio/o1.jpg",
    ],
  },
  {
    id: "rateni",
    prio: 6,
    cliente: "Sig.ra Rateni",
    zona: "Appartamento · Zona Tufello",
    cover: "/assets/lavori/lamatura/b3.jpg",
    lavori: [
      "Lamatura del parquet",
      "Posa del battiscopa",
      "Ciclo all'acqua, 3 mani Loba",
    ],
    recensione: null,
    foto: [
      "/assets/lavori/lamatura/b3.jpg",
      "/assets/lavori/lamatura/a5.jpg",
      "/assets/lavori/lamatura/b1.jpg",
      "/assets/lavori/lamatura/b2.jpg",
      "/assets/lavori/lamatura/b4.jpg",
      "/assets/lavori/lamatura/b5.jpg",
      "/assets/lavori/lamatura/a2.jpg",
      "/assets/lavori/lamatura/a3.jpg",
      "/assets/lavori/lamatura/a1.jpg",
      "/assets/lavori/lamatura/a4.jpg",
    ],
  },
];
